import * as ng from 'angular';
import { ComponentRegistration } from '../../core';
import { Moment } from 'moment';
import { ISessionService } from '../../services';
import { IMessageResource } from './data/message';
let template = require('./message.html');
let messageDetailTemplate = require('./message-detail.html');

class MessageComponent extends ComponentRegistration {

    constructor() {
        super('message', {
            controller: MessageController,
            controllerAs: 'message',
            templateUrl: template,
            bindings: {
            }
        });
    }
}

interface IMessageController {
    convertDateToDays(date): string;
    showMessageDetail(ev, msg): any;
}

class MessageController implements IMessageController {
    private static $inject: Array<string> = ['Message', 'Session', '$scope', '$mdDialog', '$mdMedia', 'moment'];

    public messages:Array<any> = [];
    public customFullscreen: Boolean;
    public useFullScreen: Boolean;

    constructor(private Message: IMessageResource,
        private Session: ISessionService,
        private $scope: ng.IScope,
        private $mdDialog: ng.material.IDialogService,
        private $mdMedia: ng.material.IMedia,
        private moment: Moment) {

        console.log('MessageController loading');
     

        this.customFullscreen = this.$mdMedia('xs') || this.$mdMedia('sm');
        this.useFullScreen = (this.$mdMedia('sm') || this.$mdMedia('xs')) && this.customFullscreen;
    }

    public $onInit(): void {
        if (!this.Session.assureActiveUserSession()) return;
        this.Session.getSessionAsync()
            .then((session) => {
                let criteria = {
                    accountId: session.account.id,
                    userProfileId: session.profile.id,
                    expirationDate: (this.moment as any)().format("MM/DD/YYYY")
                }
                this.Message.query(criteria).$promise
                    .then((response) => {
                        this.messages = response;
                    })
                    .catch((e) => {
                        console.log(e);
                    });
     
            });
        console.log('MessageController loaded');
    }

    public convertDateToDays(date): string {
        let messageExpirationDate = (this.moment as any)(date);
        let currentDate = (this.moment as any)();

        return messageExpirationDate.endOf('day').diff(currentDate, 'days');
    }

    public showMessageDetail(ev, msg): any {
        this.useFullScreen = (this.$mdMedia('sm') || this.$mdMedia('xs')) && this.customFullscreen;
        this.$mdDialog.show({
            controller: ['$scope', '$mdDialog', ($scope, $mdDialog) => {
                $scope.msg = msg;
                $scope.cancel = () => {
                    $mdDialog.cancel();
                };
            }],
            templateUrl: messageDetailTemplate,
            parent: ng.element(document.body),
            targetEvent: ev,
            clickOutsideToClose: true,
            fullscreen: this.useFullScreen
        } as any);
        let self = this;
        this.$scope.$watch(() => {
            return self.$mdMedia('xs') || self.$mdMedia('sm');
        }, (wantsFullScreen) => {
            self.customFullscreen = (wantsFullScreen === true);
        });
    };

}

let msgComponent = new MessageComponent();
export default msgComponent;
export { msgComponent as MessageComponent, IMessageController, MessageController }


// WEBPACK FOOTER //
// ./node_modules/source-map-loader!./app/components/dashboard/message.ts